import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { useCloudAccounts } from './useAccountId'

export const useValidateCloudRoute = (
  product: 'flyout' | 'oppsync' | 'cloudfaas',
  basePath: string = '/flyout',
  skipRedirect: boolean = false
) => {
  const navigate = useNavigate()
  const { cloud: routeCloud, accountId: routeAccountId } = useParams<{
    cloud?: string
    accountId?: string
  }>()

  const marketplaceCloudAccounts = useCloudAccounts(product)

  const supportedClouds = ['aws', 'azure', 'gcp']
  const isCloudSupported =
    routeCloud && supportedClouds.includes(routeCloud.toLowerCase())

  useEffect(() => {
    if (!skipRedirect && routeCloud && routeAccountId && !isCloudSupported) {
      const supportedAccounts = marketplaceCloudAccounts.filter(account =>
        supportedClouds.includes(account.provider.toLowerCase())
      )
      const firstSupportedCloud =
        supportedAccounts.length > 0
          ? supportedAccounts[0].provider.toLowerCase()
          : 'aws'

      const currentPath = window.location.pathname
      const pathParts = currentPath.split('/')
      const cloudIndex = pathParts.findIndex(part => part === routeCloud)

      if (cloudIndex !== -1) {
        pathParts[cloudIndex] = firstSupportedCloud
        navigate(pathParts.join('/'), { replace: true })
      } else {
        const restOfPath = currentPath.split(routeCloud)[1] || ''
        navigate(
          `${basePath}/${firstSupportedCloud}/${routeAccountId}${restOfPath}`,
          { replace: true }
        )
      }
    }
  }, [
    routeCloud,
    routeAccountId,
    isCloudSupported,
    marketplaceCloudAccounts,
    navigate,
    skipRedirect,
    basePath,
  ])

  return {
    isCloudSupported: !!isCloudSupported,
    routeCloud,
    routeAccountId,
  }
}
